<template>
  <div class="d-flex align-center">
    <div
      class="emoji-container"
      id="emoji-dialog"
      :class="{ 'emoji-open': emojiDialog }"
    >
      <VEmojiPicker @select="selectEmoji" />
    </div>
    <span
      class="action-icon"
      id="emoji-trigger"
      @click="emojiDialog = !emojiDialog"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.6"
        height="16.6"
        viewBox="0 0 16.6 16.6"
      >
        <defs></defs>
        <g id="ic_emoji" opacity="0.5" transform="translate(-26.4 -19.7)">
          <path
            id="Path_10451"
            fill="none"
            stroke="#000"
            stroke-miterlimit="10"
            stroke-width="0.6px"
            d="M34.7 20a8 8 0 1 0 8 8 8.03 8.03 0 0 0-8-8zm0 15.657A7.657 7.657 0 1 1 42.357 28a7.664 7.664 0 0 1-7.657 7.657z"
          />
          <path
            id="Path_10452"
            d="M43.917 50.084a2.771 2.771 0 0 1-2.678-2.884H40.9a3.116 3.116 0 0 0 3.021 3.227h.1a3.138 3.138 0 0 0 3.124-3.021H46.8a2.75 2.75 0 0 1-2.883 2.678z"
            class="cls-3"
            transform="translate(-9.32 -17.861)"
          />
          <path
            id="Path_10453"
            d="M40.047 35.245h.343a1.539 1.539 0 0 0-1.545-1.545 1.524 1.524 0 0 0-1.545 1.545h.343a1.355 1.355 0 0 1 .343-.858 1.139 1.139 0 0 1 .858-.343 1.292 1.292 0 0 1 1.203 1.201z"
            class="cls-3"
            transform="translate(-6.961 -8.996)"
          />
          <path
            id="Path_10454"
            fill="none"
            stroke="#000"
            stroke-linecap="square"
            stroke-miterlimit="10"
            stroke-width="0.6px"
            d="M53.845 33.8a1.524 1.524 0 0 0-1.545 1.545h.343a1.355 1.355 0 0 1 .343-.858 1.139 1.139 0 0 1 .858-.343 1.194 1.194 0 0 1 1.2 1.2h.343a1.539 1.539 0 0 0-1.542-1.544z"
            transform="translate(-16.81 -9.062)"
          />
        </g>
      </svg>
    </span>
  </div>
</template>

<script>
import { VEmojiPicker } from "v-emoji-picker";
export default {
  name: "emoji",
  props: {
    emojiDialogState: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VEmojiPicker,
  },
  data() {
    return {
      emojiDialog: false,
    };
  },
  mounted() {
    const clickOutsideEmoji = (e) => {
      if (
        document.getElementById("emoji-dialog") &&
        !document.getElementById("emoji-dialog").contains(e.target) &&
        !document.getElementById("emoji-trigger").contains(e.target)
      ) {
        this.emojiDialog = false;
      }
    };
    document.addEventListener("click", clickOutsideEmoji);
  },
  methods: {
    selectEmoji(emoji) {
      this.$emit("sendText", emoji.data);
      console.log(emoji);
    },
  },
  watch: {
    emojiDialogState() {
      this.emojiDialog = this.emojiDialogState;
    },
  },
};
</script>

<style lang="scss">
.emoji-container {
  visibility: hidden;
  position: absolute;
  bottom: 55px;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  .emoji-picker {
    width: 100% !important;
    border-radius: 8px;
    background-color: #fdfdfd !important;
    border: 1px solid #eee;
    box-shadow: 0px 0px 14px #0000001a;
    .container-search input {
      background-color: white !important;
    }
    .grid-emojis {
      grid-template-columns: repeat(10, 10%) !important;
    }
    #Categories {
      overflow-x: hidden !important;
    }
  }
}
.emoji-open {
  visibility: visible;
  opacity: 1;
}
.cls-3 {
  fill: none;
  stroke: #000;
  stroke-miterlimit: 10;
  stroke-width: 0.6px;
  stroke-linecap: round;
}
</style>
